import { ErrorLike } from '../core/error-like.js';
import { OperationResponse } from '../core/operation-response.js';
import { DataModel, toData } from '../dto/dto.js';

export class ApiLazyLoadResponse<T extends DataModel> {
  private constructor(
      public readonly success: boolean,
      public readonly error: ErrorLike | null,
      public readonly batch: T[] | null,
      public readonly canLoadMore: boolean,
      public readonly startAfter: NonNullable<unknown> | null,
  ) {}

  static success<T extends DataModel>(batch: T[], canLoadMore: boolean, startAfter: NonNullable<unknown> | null) : ApiLazyLoadResponse<T> {
    return new ApiLazyLoadResponse<T>(
        true,
        null,
        batch,
        canLoadMore,
        startAfter
    );
  }

  static error<T extends DataModel>(error: ErrorLike) : ApiLazyLoadResponse<T> {
    return new ApiLazyLoadResponse<T>(
        false,
        error,
        null,
        false,
        null
    );
  }

  static fromErrorResponse<T extends DataModel>(response: OperationResponse<T>) : ApiLazyLoadResponse<T> {
    return new ApiLazyLoadResponse<T>(
        false,
        response.error,
        null,
        false,
        null
    );
  }

  toMap(): Record<string, unknown> {
    return {
      'success': this.success,
      'error': this.error,
      'batch': this.batch?.map((e) => toData(e)) ?? null,
      'canLoadMore': this.canLoadMore,
      'startAfter': this.startAfter,
    };
  }
}
